module.exports = __webpack_public_path__ + "img/tx.787bc804.svg";